module.exports = __webpack_public_path__ + "img/右下0.86f66a14.png";